// 数据展示的格式化规则，见 web/admin/README.md 的"数据展示"一节。
import { toBeijing } from "./beijing";

/** 微单位整数金额转展示字符串。IDR、JPY、KRW 不带小数，其余 4 位。 */
export function formatMoney(micro: number | string | bigint, currency?: string, digits?: number): string {
  const n = Number(micro) / 1e6;
  const d = digits ?? (currency === "IDR" || currency === "JPY" || currency === "KRW" ? 0 : 4);
  const s = n.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
  return currency ? `${s} ${currency}` : s;
}

/** E.164 数字串补加号，不分组。 */
export function formatMsisdn(msisdn: string): string {
  return msisdn ? "+" + msisdn.replace(/^\+/, "") : "";
}

/** ISO 时间转北京时间（D174）的 YYYY-MM-DD HH:mm:ss。 */
export function formatTime(iso: string | Date, withSeconds = true): string {
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return "";
  const d = toBeijing(at);
  const p = (x: number) => (x < 10 ? "0" : "") + x;
  const base = `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
  return withSeconds ? `${base}:${p(d.getUTCSeconds())}` : base;
}

/** UUID 取末 8 位：ID 是 UUID v7（决策 D12），前 48 位是毫秒时间戳，同一时段的消息前缀相同，末尾是随机数才分得开（#541，D199）。 */
export function shortId(id: string): string {
  return id.slice(-8);
}
